export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7675.f42b2bbb.jpg";